<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'6-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>결제 관리 - 바로결제 관리</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form(1)">URL 생성</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_name'>예약자명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_name'
                maxLength="50"
                placeholder = "예약자명 입력해 주세요."
                v-model="formData.reservationCustomerName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_phone_number'>휴대폰번호<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_phone_number'
                maxLength="50"
                placeholder = "예약자명 입력해 주세요."
                v-model="formData.reservationCustomerPhoneNumber"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerPhoneNumberError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_email'>이메일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요."
                v-model="formData.reservationCustomerEmail"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerEmailError}}</p>
          </div>

          <div>
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_expected_payment_amount'>결제금액<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_expected_payment_amount'
                maxLength="13"
                placeholder = "결제예정금액을 입력해 주세요."
                v-model="formData.reservationExpectedPaymentAmount"
                @input="formatAmount"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationExpectedPaymentAmountError}}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'

import {
  removeWhitespacePhone,
  validatePhone,
  removeWhitespace,
  validateEmail
} from '../../ETC/Validation.vue'
import {
  base_homepage_url_export
} from '../../ETC/Axios.vue'
export default {
  name: 'AdminBenefitsManagement',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  data () {
    return {
      formData: ref({
        reservationCustomerName: '',
        reservationCustomerPhoneNumber: '',
        reservationCustomerEmail: '',
        reservationExpectedPaymentAmount: '0'
      }),
      errorData: ref({
        reservationCustomerNameError: '',
        reservationCustomerPhoneNumberError: '',
        reservationCustomerEmailError: '',
        reservationExpectedPaymentAmountError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        reservationCustomerPhoneNumberStatus: false,
        reservationCustomerEmailStatus: true
      })
    }
  },
  watch: {
    'formData.reservationCustomerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.reservationCustomerPhoneNumberError = '휴대전화는 필수로 입력하셔야 합니다.'
        this.statusData.reservationCustomerPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.reservationCustomerPhoneNumberError = ''
        this.statusData.reservationCustomerPhoneNumberStatus = true
      } else {
        this.errorData.reservationCustomerPhoneNumberError = '휴대폰번호 형식으로 입력하셔야 합니다.'
        this.statusData.reservationCustomerPhoneNumberStatus = false
      }
    },
    'formData.reservationCustomerEmail': function (value) {
      this.formData.reservationCustomerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.reservationCustomerEmailError = ''
        this.statusData.reservationCustomerEmailStatus = true
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.reservationCustomerEmailError = ''
        this.statusData.reservationCustomerEmailStatus = true
      } else {
        this.errorData.reservationCustomerEmailError = '이메일 형식으로 입력하셔야 합니다.'
        this.statusData.reservationCustomerEmailStatus = false
      }
    }
  },
  methods: {
    formatAmount () {
      let value = this.formData.reservationExpectedPaymentAmount.replace(/\D/g, '')
      value = Number(value).toLocaleString()
      this.formData.reservationExpectedPaymentAmount = value
    },
    check_form: function (division) {
      let continue_add = true
      if (this.formData.reservationCustomerName === '') {
        this.errorData.reservationCustomerNameError = '예약자명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationCustomerNameError = ''
      }
      if (this.formData.reservationCustomerPhoneNumber === '') {
        this.errorData.reservationCustomerPhoneNumberError = '휴대전화를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationCustomerPhoneNumberError = ''
      }
      if (this.formData.reservationExpectedPaymentAmount === '') {
        this.errorData.reservationExpectedPaymentAmountError = '결제예정금액을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationExpectedPaymentAmountError = ''
      }
      if (
        continue_add &&
        this.statusData.reservationCustomerPhoneNumberStatus &&
        this.statusData.reservationCustomerEmailStatus
      ) {
        const data = {
          name: this.formData.reservationCustomerName,
          phone: this.formData.reservationCustomerPhoneNumber,
          email: this.formData.reservationCustomerEmail,
          amount: this.formData.reservationExpectedPaymentAmount
        }
        const queryParams = new URLSearchParams(data).toString()
        const make_url = `${base_homepage_url_export}OrderImmediate?${queryParams}`
        navigator.clipboard.writeText(make_url).then(() => {
          alert('URL이 클립보드에 복사되었습니다.')
        }).catch(err => {
          alert('URL 복사에 실패했습니다.')
          console.error('URL 복사 에러:', err)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/OrderDeliveryManagement/AdminImmediatePaymentManagement.vue